import { useRouterState } from '@tanstack/react-router';

/**
 * Экран переписки, а не адрес переписки.
 *
 * Тред открывается двумя путями: по своему адресу `/chats/$chatId` и по `?peerUserId=` из
 * списков людей – кнопкой «Написать». Второй путь остаётся на индексном маршруте `/chats`, и по
 * одному адресу его от списка переписок не отличить.
 */
export const useIsChatThread = () =>
  useRouterState({
    select: (state) =>
      state.matches?.some(
        (match) =>
          match.routeId.includes('/chats/$chatId') ||
          (match.routeId.includes('/dashboard/chats/') &&
            Boolean((match.search as { peerUserId?: string } | undefined)?.peerUserId))
      ) ?? false,
  });
